module.exports = __webpack_public_path__ + "static/media/Screenshot_58.decc03ec.png";